// LAYOUT
import '../layout.js';

// GSAP
import { gsap , ScrollSmoother , ScrollTrigger } from "../layout.js";
import { gsapSmoothScrollObj } from "../layout.js";

// GALLERY
import lightGallery from 'lightgallery';

// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

lightGallery(document.getElementById('lightgallery'), {
    plugins: [lgZoom, lgThumbnail],
});